export default {"src":"/_next/static/media/WhoWeAre_002A.ac28be9f.JPG","height":694,"width":1920};